const breadcrumb = {
    title: {
        dashboard: 'Dashboard',
        user: 'Users',
        offer: 'Offers',
        order: 'Orders',
        advertiser: 'Advertisers',
        publisher: 'Publishers',
        affiliate: 'Affiliates',
        smartCpa: 'Smart Cpa',
        category: 'Categories',
        landing: 'Landings',
        campaign: 'Campaigns',
        lead: 'Leads',
        site: 'Site',
        filter: 'Filters',
        parameters: 'Parameters',
        connector: 'Connectors',
        apiEndpoints: 'API Endpoints',
        prelander: 'Prelanders',
        demand: 'Demands',
        commissionEvents: 'Commission Events',
        commissionPlans: 'Commission Plans',
        devalidationImport: 'Devalidation Import',
        profile: 'Profile',
        migrationIssues: 'Migration issues',
    },
    shortcut: {
        home: 'Home',
        user: 'Users list',
        'user-add': 'Add a user',
        'user-edit': 'Edit a user',
        offer: 'Offers list',
        'offer-add': 'Add a offer',
        'offer-edit': 'Edit a offer',
        advertiser: 'Advertisers list',
        'advertiser-add': 'Add an advertiser',
        'advertiser-edit': 'Edit an advertiser',
        publisher: 'Publishers list',
        'publisher-add': 'Add an publisher',
        'publisher-edit': 'Edit an publisher',
        affiliate: 'Affiliates list',
        'affiliate-add': 'Add an affiliate',
        'affiliate-edit': 'Edit an affiliate',
        smartCpa: 'Smart Cpa list',
        'smartCpa-add': 'Add a Smart Cpa',
        'smartCpa-edit': 'Edit a Smart Cpa',
        category: 'Categories list',
        'category-add': 'Add a category',
        'category-edit': 'Edit a category',
        order: 'Orders list',
        'order-add': 'Add an order',
        'order-edit': 'Edit an order',
        campaign: 'Campaigns list',
        'campaign-add': 'Add a campaign',
        'campaign-edit': 'Edit a campaign',
        lead: 'Leads list',
        'lead-add': 'Add a lead',
        'lead-edit': 'Edit a lead',
        site: 'Site',
        'site-edit': 'Edit a site',
        filter: 'Filters',
        parameters: 'Parameters',
        connector: 'Connectors list',
        'connector-add': 'Add a connector',
        'connector-edit': 'Edit a connector',
        'apiEndpoints': 'API Endpoints',
        'apiEndpoints-add': 'Add an API endpoint',
        'apiEndpoints-edit': 'Edit an API endpoint',
        prelander: 'Prelanders list',
        'prelander-add': 'Add a prelander',
        'prelander-edit': 'Edit a prelander',
        demand: 'Demands list',
        commissionEvents: 'Commission Events list',
        commissionPlans: 'Commission Plans list',
        devalidationImport: 'Devalidation Import',
        profile: 'Profile',
        migrationIssues: 'Migration issues',
    },
}

export default breadcrumb
